import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, Route, HashRouter as Router, Routes } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import PrivateRoute from './PrivateRoute';
import DashboardLayout from './Components/Dashboard/DashboardLayout';
import Login from './Login/Login';
import { AuthProvider } from './Context/AuthContext';
import InvoicePage from './BackEnd/Home/Invoice';
import Unauthorized from './BackEnd/Unauthorized';

const App: React.FC = () => {
  const [token, setToken] = useState<string | null>(() => {
    return localStorage.getItem("accessToken");
  });

  const handleLogin = (accessToken: string, refreshToken?: string) => {
    setToken(accessToken);
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken || '');
  };

  const handleLogout = useCallback(async () => {
    // try {
    //   let response = await http.post('Vyapar/User/logout', { refreshToken: localStorage.getItem('refreshToken') });

    //   if (response) {
    //     setToken(null);
    //     localStorage.removeItem('accessToken');
    //     localStorage.removeItem('refreshToken');
    //     setIsAccessToLogin(true);
    //   }

    // } catch (error) {
    //   console.error('failed to logout', error);
    // }

    setToken(null);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
  }, []);

  useEffect(() => {
    if (!token) {
      window.location.pathname = "/login";
    }
  }, [token]);

  return (
    <AuthProvider token={token} handleLogin={handleLogin} handleLogout={handleLogout}>
      <Router>
        <CssBaseline />

        <Routes>
          <Route
            path="/login"
            element={!token ? <Login onLogin={handleLogin} /> : <Navigate to="/" />}
          />
          <Route path="/unauthorized" element={<Unauthorized />} />

          <Route
            path="/"
            element={token ? <DashboardLayout /> : <Navigate to="/login" />}
          >
            <Route index element={<InvoicePage />} />
            <Route path="*" element={<PrivateRoute token={token} />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;